import { render, staticRenderFns } from "./movie-swipe.vue?vue&type=template&id=c9901b90&scoped=true"
import script from "./movie-swipe.vue?vue&type=script&lang=js"
export * from "./movie-swipe.vue?vue&type=script&lang=js"
import style0 from "./movie-swipe.vue?vue&type=style&index=0&id=c9901b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9901b90",
  null
  
)

export default component.exports